const apiUrl = 'http://www.chbd.net/api/v1/';
const wwwUrl = 'http://www.chbd.net/';
const userInfo = null;
const token = '';
const classlist = []; //分类列表
const adveradmin = false; //广告管理
const memberdiypages = {}; //会员配置
const indexdiypages = []; //首页配置

function getUrlParam(name) { // 获取url参数值
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  //构造一个含有目标参数的正则表达式对象
  var str = window.location.href.split("?")[1];
  if (str) {
    var r = str.substr(0).match(reg);
    // 匹配目标参数
    if (r != null)
      return decodeURI(r[2]);
    return '';
  } else {
    return ''
  }
}

function passworld(password) {
  var reg = /[@#\$%\^&\*]+/g;
  if (password.length < 6) {
    return 1;
  }
  if (reg.test(password)) {
    return 2;
  }
  return 3;
}
//日期
function timeData(value) {
  var date = new Date(value);
  var month = (date.getMonth() + 1);
  var day = date.getDate();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  var date_value = date.getFullYear() + '-' + month + '-' + day;
  return date_value
}
//时间
function timeTime(value) {
  var date = new Date(value);
  var year = date.getFullYear() + '年'
  var month = (date.getMonth() + 1) + '月';
  var day = date.getDate() + '日';
  var hour = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
  var minter = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
  var secod = date.getSeconds();
  if (month < 10) {
    month = '0' + month
  }
  if (day < 10) {
    day = '0' + day
  }
  var date_value = year + month + day + ' ' + hour + minter + secod;
  return date_value
}

//转换时间
function changeTime(date, start = 0, number = 6) {
  var newDate = new Date(date);

  var year = newDate.getFullYear() + "-";
  var month = newDate.getMonth() + 1 + "-";
  var day = newDate.getDate() + " ";
  var hour = newDate.getHours();
  var minutes = ":" + newDate.getMinutes();
  var seconds = ":" + newDate.getSeconds();
  var str = [year, month, day, hour, minutes, seconds];
  str = str.splice(start, number).join("");
  return str;
}
export default {
  apiUrl, //api地址
  wwwUrl, //网站
  userInfo, //用户信息
  token, //用户token
  classlist,
  adveradmin,
  memberdiypages,
  indexdiypages,
  getUrlParam: getUrlParam,
  timeData: timeData,
  timeTime: timeTime,
  changeTime: changeTime
}



// WEBPACK FOOTER //
// ./src/api/globalVariable.js